// Perfect Dropshipping Theme JavaScript

// Toggle mobile menu
function toggleMenu() {
  document.getElementById('mobileMenu').classList.toggle('active');
}

// Update cart count
fetch('/cart.js')
  .then(res => res.json())
  .then(data => {
    const count = document.querySelector('.cart-count');
    if (count) count.textContent = data.item_count;
  });
